export var SlideDirection;
(function (SlideDirection) {
    SlideDirection["ToRight"] = "slide-to-right";
    SlideDirection["ToLeft"] = "slide-to-left";
    SlideDirection["ToTop"] = "slide-to-top";
})(SlideDirection || (SlideDirection = {}));
//# sourceMappingURL=SlideDirection.js.map